import request from '@/utils/request'

const prefix = '/api/v1/back'


/**
 * 院校基础参数（查询列表）
 * @param {*} query
 */
export const paramlist = (query) => {
    return request({
        url: `${prefix}/collegeBasic/param/list`,
        method: 'get',
        params: query
    })
}

/**
 * 院校基础参数（删除）
 * @param {*} query
 */
export const paramDelete = (query) => {
    return request({
        url: `${prefix}/collegeBasic/param`,
        method: 'delete',
        data: query
    })
}

/**
 * 院校基础参数（创建）
 * @param {*} query
 */
export const paramCreate = (query) => {
    return request({
        url: `${prefix}/collegeBasic/param`,
        method: 'post',
        data: query
    })
}

/**
 * 院校基础参数（修改）
 * @param {*} query
 */
export const paramEdit = (query) => {
    return request({
        url: `${prefix}/collegeBasic/param`,
        method: 'put',
        data: query
    })
}

/**
 * 院校基础（查询列表）
 * @param {*} query
 */
export const collegeBasiclist = (query) => {
    return request({
        url: `${prefix}/collegeBasic/list`,
        method: 'get',
        params: query
    })
}


/**
 * 院校基础内容（查询列表）
 * @param {*} query
 */
export const contentlist = (query) => {
    return request({
        url: `${prefix}/collegeBasic/content/list`,
        method: 'get',
        params: query
    })
}

/**
 * 院校基础参数（删除）
 * @param {*} query
 */
export const contentDelete = (query) => {
    return request({
        url: `${prefix}/collegeBasic/content`,
        method: 'delete',
        data: query
    })
}


/**
 * 院校基础内容（查询详情）
 * @param {*} query
 */
export const contentOne = (query) => {
    return request({
        url: `${prefix}/collegeBasic/content`,
        method: 'get',
        params: query
    })
}

/**
 * 院校基础内容（创建）
 * @param {*} query
 */
export const contentEdit = (query) => {
    return request({
        url: `${prefix}/collegeBasic/content`,
        method: 'post',
        data: query
    })
}


/**
 * 用户院校基础内容申请（查询列表）
 * @param {*} query
 */
export const contentapplylist = (query) => {
    return request({
        url: `${prefix}/member/collegeBasicContent/apply/list`,
        method: 'get',
        params: query
    })
}



/**
 * 院校基础内容（查询详情）
 * @param {*} query
 */
export const contentapplyOne = (query) => {
    return request({
        url: `${prefix}/member/collegeBasicContent/apply`,
        method: 'get',
        params: query
    })
}


/**
 * 用户院校基础内容申请（审核拒绝）
 * @param {*} query
 */
export const applyreject = (query) => {
    return request({
        url: `${prefix}/member/collegeBasicContent/apply/reject`,
        method: 'put',
        data: query
    })
}


/**
 * 用户院校基础内容申请（审核通过）
 * @param {*} query
 */
export const applyapprove = (query) => {
    return request({
        url: `${prefix}/member/collegeBasicContent/apply/approve`,
        method: 'put',
        data: query
    })
}